import React from "react";
import { Box, Typography, IconButton, Avatar } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth } from "../../context/AuthContext";

const UserInfoHeader = ({ onClose }) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated || !user) return null;

  const { profile } = user;
  const initials =
    profile.firstName?.charAt(0).toUpperCase() +
    profile.lastName?.charAt(0).toUpperCase();

  return (
    <Box
      sx={{
        px: 2,
        py: 1.5,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        bgcolor: "#FAFAFA",
        borderBottom: "1px solid #eee",
        mb: 2,
      }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
        <Avatar sx={{ width: 40, height: 40, bgcolor: "#FD7762" }}>
          {initials}
        </Avatar>
        <Box>
          <Typography sx={{ fontWeight: 600, fontSize: "1rem" }}>
            {profile.firstName} {profile.lastName}
          </Typography>
          <Typography sx={{ fontSize: "0.85rem", color: "#666" }}>
            {profile.email}
          </Typography>
        </Box>
      </Box>
      <IconButton onClick={onClose}>
        <CloseIcon />
      </IconButton>
    </Box>
  );
};

export default UserInfoHeader;
